import {connect} from '@store/@common';

import {getChartOptions} from '@store/kpi/KpiObservation.selectors';

import {CoachingGoalsView} from './coaching-goals-view';
import {users} from '@store/user';
import {kpisById} from '@store/kpi';
import KpiGoalActions from '@store/kpi/KpiTargetActions';

const mapState = {
  getChartOptions,
  users,
  kpisById,
};

const mapDispatch = {
  fetchKpis: KpiGoalActions.fetchGoalKpiTree,
};

export default connect(CoachingGoalsView, mapState, mapDispatch);
